<span *ngIf="svg$ | async as svg" [innerHTML]="svg">
</span>
